<template>
  <div id="footer">
    <contact v-if="this.$isPC" />
    <sp-contact v-else v-show="position > 1400 || position == 0" />
    <div id="footer-menu">
      <div class="body">
        <div style="width: 35%;">
          <a href="/">
            <img
              src="../../assets/logo.png"
              style="width: 130px; margin: 10px 0;"
              alt="呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call"
            />
          </a>
          <div style="margin-bottom: 10px;">
            運営：株式会社 ビーアッサ<br />
            〒921-8844 石川県野々市市堀内 5-105 シャイニー堀内 1F<br />
            <a href="tel:076-294-4440" style="color: #4d4d4d;">
              TEL : 076-294-4440<br />
            </a>
            FAX : 076-294-4432<br />
            <a href="mailto:info@b-call.jp" style="color: #4d4d4d;">
              E-MAIL : info@b-call.jp
            </a>
          </div>
          <span style="font-weight: bold;">
            Copyright (C)
            <a
              href="https://b-call.jp/"
              style="text-decoration: none;color: #4d4d4d;"
            >
              呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call
            </a>
            .All Rights Reserved.
          </span>
        </div>
        <div class="menues">
          <ul>
            <li>
              <router-link to="/products">商品一覧</router-link>
            </li>
            <li v-for="(product, index) in products" :key="index">
              <router-link
                v-bind:to="{
                  name: 'ProductType',
                  params: {
                    name: product.name,
                    type: 'feature',
                  },
                }"
              >
                {{ product.displayName }}
              </router-link>
            </li>
          </ul>
          <ul>
            <li>
              <router-link to="/choice/industry">業種から選ぶ</router-link>
            </li>
            <li v-for="(industry, index) in industries" :key="'scene' + index">
              <router-link :to="'/choice/industry/' + industry.id">
                {{ industry.shortName }}
              </router-link>
            </li>
          </ul>
          <ul>
            <li v-for="(menu, index) in menues" :key="index">
              <router-link v-bind:to="menu.path">
                {{ menu.displayTitle }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '@/components/modules/Contact'
import SpContact from '@/components/modules/SpContact'

export default {
  components: {
    Contact,
    SpContact,
  },
  data() {
    return {
      products: [
        { name: 'remote-reply-call', displayName: 'リモートリプライコール' },
        {
          name: 'remote-reply-call-pc',
          displayName: 'リモートリプライコールPC',
        },
        { name: 'reply-call', displayName: 'リプライコール' },
        { name: 'reply-call-pc', displayName: 'リプライコール PC' },
        { name: 'beyond-ec', displayName: 'ビヨンドイーシー' },
        { name: 'eco-chime', displayName: 'エコチャイム' },
        { name: 'coco-call', displayName: 'コココール' },
        { name: 'fact-in-call', displayName: 'ファクトインコール' },
      ],
      menues: [
        { displayTitle: '商品の選び方', path: '/choice/purpose' },
        { displayTitle: 'よくあるご質問', path: '/faq' },
        { displayTitle: 'ご購入方法', path: '/guide' },
        { displayTitle: 'デモ機貸出し方法', path: '/rental' },
        { displayTitle: 'お知らせ', path: '/news' },
        { displayTitle: 'お役立ちコラム', path: '/columns' },
        { displayTitle: '会社案内', path: '/company' },
        {
          displayTitle: 'お見積り・デモ機貸出し・お問い合わせ',
          path: '/contact',
        },
        { displayTitle: '個人情報保護方針', path: '/privacy' },
        { displayTitle: '特定商取引に基づく表記', path: '/tradelaw' },
      ],
      industries: [
        {
          id: 1,
          shortName: '飲食店',
        },
        {
          id: 2,
          shortName: 'フードコート',
        },
        {
          id: 3,
          shortName: '工場',
        },
        {
          id: 4,
          shortName: '病院（薬局）',
        },
        {
          id: 5,
          shortName: '介護（福祉）',
        },
        {
          id: 6,
          shortName: '物流倉庫（運輸業）',
        },
        {
          id: 7,
          shortName: '焼却場・不燃物処理場',
        },
        {
          id: 8,
          shortName: 'イベント・展示会',
        },
        {
          id: 9,
          shortName: '屋外施設',
        },
        {
          id: 10,
          shortName: '大規模施設',
        },
        {
          id: 11,
          shortName: 'カー用品店',
        },
        {
          id: 12,
          shortName: '教育施設',
        },
      ],
      position: 0,
    }
  },
  mounted() {
    document.onscroll = e => {
      this.position =
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop ||
        document.body.scrollHeigh - document.body.scrollTop
    }
  },
}
</script>

<style scoped>
#footer-menu {
  height: auto;
  margin-top: 16px;

  border-top: 1px solid rgb(22, 141, 211);
  background-color: rgb(220, 238, 254);
}

#footer .body {
  font-size: 12px;

  display: flex;
  justify-content: space-between;

  width: 70%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px 0 30px;
}

#footer .body .menues ul {
  display: inline-block;

  list-style: none;

  vertical-align: top;
}

#footer .body .menues ul li a {
  text-decoration: none;

  color: #4d4d4d;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/FooterMenu.vue